import { Flex, Typography } from "antd"
import React, { type ReactNode } from "react"

import { WorkspaceCardValue } from "../../Lead/LeadWorkspacePage/cards/WorkspaceCardValue.tsx"

const { Text } = Typography

interface CustomerDetailFieldProps {
  label: string
  value?: ReactNode
  placeholder?: string
  children?: ReactNode
}

function CustomerDetailField({
  label,
  value,
  placeholder,
  children
}: CustomerDetailFieldProps) {
  return (
    <Flex vertical gap={2} className={"min-w-0"}>
      <Text type={"secondary"} className={"text-xs"}>
        {label}
      </Text>
      <WorkspaceCardValue
        value={value === undefined && children != null ? true : value}
        placeholder={placeholder}
      >
        {children}
      </WorkspaceCardValue>
    </Flex>
  )
}

export { CustomerDetailField }
